<template>
  <MglMarker :coordinates="coordinates">
    <div slot="marker" class="vessel-marker">
      <div class="marker-icon-container" :style="{ background: color }">
        <v-icon color="white" size="20" slot="marker">{{ icon }}</v-icon>
      </div>
    </div>
  </MglMarker>
</template>
  
  <script>
import { MglMarker } from "vue-mapbox";

export default {
  name: "SimpleMarker",
  components: {
    MglMarker,
  },
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      required: true,
      default: "mdi-ferry",
    },
    color: {
      type: String,
      required: true,
      default: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    },
  },
};
</script>
  
  <style scoped>
.vessel-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vessel-marker:hover {
  transform: translateY(-2px);
}

.marker-icon-container {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 3px solid white;
  transition: all 0.3s ease;
  position: relative;
}

.marker-icon-container::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: inherit;
  border-radius: 50%;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.vessel-marker:hover .marker-icon-container {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.vessel-marker:hover .marker-icon-container::before {
  opacity: 0.3;
}

.marker-label {
  margin-top: 2px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 4px 12px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.marker-label span {
  font-size: 12px;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
}

.fouling-status {
  margin-top: 2px;
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  backdrop-filter: blur(5px);
}

.fouling-text {
  font-size: 10px !important;
  font-weight: 500 !important;
  color: white !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.vessel-marker:hover .marker-label {
  background: rgba(255, 255, 255, 1);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
  
  